export function openCloseFilter() {
    var aside = $(".filter-aside");
    var asideButtonOpen = aside.find(".overview-aside-open");

    $(asideButtonOpen).on("click", function (e) {
        e.preventDefault();
        aside.toggleClass("active");
    });

    $("body").on("click", function (e) {
        var target = e.target;

        if(!$(target).closest(".related-aside, .jcf-select-drop, .overview-aside-open").length) {
            aside.removeClass("active");
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/openCloseFilter.js